export const cleanQuillHTML = (html) => {
  if (!html) return "";

  return html
    .replace(/&nbsp;/g, " ")
    .replace(/\u00A0/g, " ");
};